import { motion } from 'framer-motion';

import BusinessRequest from '../../components/BusinessRequest';
import BusinessText from '../../components/BusinessText';
import {
  businessContent,
  requestContent,
  customerTextContent,
  testimonialText,
  testimonialAttribution,
  requestIcon,
} from './content';
import CustomerText from '../../components/CustomerText';
import customerImage from '../../assets/payments-user.png';
import PaymentReceived from '../../components/PaymentReceived';
import Testimonial from '../../components/Testimonial';
import testimonialImage from '../../assets/payments-quote-user.png';
import { getFadeUpAnimationProps, getPopAnimationProps } from '../../utils';
import BoxWrapper from '../../components/BoxWrapper';

const Payments = () => {
  return (
    <>
      <BoxWrapper marginTop="40px">
        <motion.div {...getPopAnimationProps(1, 0.75)}>
          <BusinessText content={businessContent} />
        </motion.div>
        <motion.div {...getPopAnimationProps(1.5, 0.75)}>
          <BusinessRequest
            icon={requestIcon}
            content={requestContent}
            width="218px"
          />
        </motion.div>
      </BoxWrapper>
      <BoxWrapper>
        <motion.div {...getPopAnimationProps(2.5, 0.75)}>
          <CustomerText
            image={customerImage}
            width="279px"
            content={customerTextContent}
          />
        </motion.div>
      </BoxWrapper>
      <BoxWrapper>
        <motion.div {...getPopAnimationProps(3, 0.65)}>
          <PaymentReceived customerName="Sarah Covey" amount="1,500.00" />
        </motion.div>
      </BoxWrapper>
      <BoxWrapper marginTop="40px">
        <motion.div {...getFadeUpAnimationProps(3.75, 0.4)}>
          <Testimonial
            image={testimonialImage}
            text={testimonialText}
            attribution={testimonialAttribution}
          />
        </motion.div>
      </BoxWrapper>
    </>
  );
};

export default Payments;
